const COLORS = [
  "#FF6B6B", "#FF9F43", "#FECA57", "#48DBFB", "#FF9FF3",
  "#54A0FF", "#5F27CD", "#01CBC6", "#10AC84", "#EE5A24",
];

function colorFromName(name: string): string {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return COLORS[Math.abs(hash) % COLORS.length];
}

function initials(name: string): string {
  return name
    .split(" ")
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() ?? "")
    .join("");
}

interface AvatarProps {
  name: string;
  size?: "sm" | "md" | "lg";
  selected?: boolean;
  onClick?: () => void;
}

const sizeMap = { sm: "w-8 h-8 text-xs", md: "w-10 h-10 text-sm", lg: "w-12 h-12 text-base" };

export function Avatar({ name, size = "md", selected = false, onClick }: AvatarProps) {
  const bg = colorFromName(name);
  const baseClass = `relative inline-flex items-center justify-center rounded-full font-semibold text-white shrink-0
    ${sizeMap[size]} ${selected ? "ring-2 ring-offset-1 ring-fg" : ""}`;

  if (onClick) {
    return (
      <button
        onClick={onClick}
        className={`${baseClass} active:opacity-70 transition-opacity`}
        style={{ backgroundColor: bg }}
        title={name}
      >
        {initials(name)}
      </button>
    );
  }
  return (
    <div
      className={baseClass}
      style={{ backgroundColor: bg }}
      title={name}
    >
      {initials(name)}
    </div>
  );
}
